import { HttpClient } from './HttpClient';
import { getApiUrl } from './UrlBuilder';

import { HALManager, UserManager } from 'core';
import { AboutMe } from 'models';

export class AboutMeService {
  private httpClient: HttpClient = new HttpClient();

  public async getAboutMe() {
    const urlRequest = getApiUrl(HALManager.getAboutMeUrl(UserManager.userId));

    const response = await this.httpClient.get<AboutMe>(urlRequest);

    return response.object;
  };

  public async updateAboutMe(aboutMe: AboutMe) {
    const requestParams = { body: JSON.stringify(aboutMe) };

    const urlRequest = getApiUrl(HALManager.updateAboutMeUrl(UserManager.userId));

    const response = await this.httpClient.put<AboutMe>(urlRequest, requestParams);

    return response.object;
  };
}

export default new AboutMeService();
